// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies
// @generated from protobuf file "backend/test_run_service.proto" (package "tusk.drift.backend.v1", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { MatchLevel } from "../core/span";
import { Span } from "../core/span";
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansRequest
 */
export interface GetGlobalSpansRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * Optional since first page will have no cursor
     *
     * @generated from protobuf field: optional string pagination_cursor = 2
     */
    paginationCursor?: string;
    /**
     * Server should provide next cursor based on this page size
     *
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansResponseSuccess
 */
export interface GetGlobalSpansResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.core.v1.Span spans = 1
     */
    spans: Span[];
    /**
     * @generated from protobuf field: optional string next_cursor = 2
     */
    nextCursor?: string;
    /**
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansResponseError
 */
export interface GetGlobalSpansResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansResponse
 */
export interface GetGlobalSpansResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetGlobalSpansResponseSuccess success = 1
         */
        success: GetGlobalSpansResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetGlobalSpansResponseError error = 2
         */
        error: GetGlobalSpansResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansRequest
 */
export interface GetPreAppStartSpansRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string pagination_cursor = 2
     */
    paginationCursor?: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansResponseSuccess
 */
export interface GetPreAppStartSpansResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.core.v1.Span spans = 1
     */
    spans: Span[];
    /**
     * @generated from protobuf field: optional string next_cursor = 2
     */
    nextCursor?: string;
    /**
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansResponseError
 */
export interface GetPreAppStartSpansResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansResponse
 */
export interface GetPreAppStartSpansResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetPreAppStartSpansResponseSuccess success = 1
         */
        success: GetPreAppStartSpansResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetPreAppStartSpansResponseError error = 2
         */
        error: GetPreAppStartSpansResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateDriftRunRequest
 */
export interface CreateDriftRunRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: string cli_version = 2
     */
    cliVersion: string;
    /**
     * These fields are optional for validation runs
     *
     * @generated from protobuf field: optional string commit_sha = 3
     */
    commitSha?: string;
    /**
     * @generated from protobuf field: optional string pr_number = 4
     */
    prNumber?: string;
    /**
     * @generated from protobuf field: optional string branch_name = 5
     */
    branchName?: string;
    /**
     * @generated from protobuf field: optional string external_check_run_id = 6
     */
    externalCheckRunId?: string;
    /**
     * Indicates this is a validation run on the default branch
     *
     * @generated from protobuf field: bool is_validation_run = 7
     */
    isValidationRun: boolean;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateDriftRunResponseSuccess
 */
export interface CreateDriftRunResponseSuccess {
    /**
     * @generated from protobuf field: string drift_run_id = 1
     */
    driftRunId: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateDriftRunResponseError
 */
export interface CreateDriftRunResponseError {
    /**
     * Machine-readable error code, could be an enum
     *
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * Human-readable error message
     *
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateDriftRunResponse
 */
export interface CreateDriftRunResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.CreateDriftRunResponseSuccess success = 1
         */
        success: CreateDriftRunResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.CreateDriftRunResponseError error = 2
         */
        error: CreateDriftRunResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsRequest
 */
export interface GetDriftRunTraceTestsRequest {
    /**
     * @generated from protobuf field: string drift_run_id = 1
     */
    driftRunId: string;
    /**
     * @generated from protobuf field: optional string pagination_cursor = 2
     */
    paginationCursor?: string;
    /**
     * Server should provide next cursor based on this page size
     *
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.TraceTest
 */
export interface TraceTest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string; // DB id
    /**
     * @generated from protobuf field: string trace_id = 2
     */
    traceId: string;
    /**
     * @generated from protobuf field: string server_span_recording_id = 3
     */
    serverSpanRecordingId: string;
    /**
     * @generated from protobuf field: repeated tusk.drift.core.v1.Span spans = 4
     */
    spans: Span[];
    /**
     * Status of the trace test (DRAFT, IN_SUITE, REMOVED)
     *
     * @generated from protobuf field: tusk.drift.backend.v1.TraceTestStatus status = 5
     */
    status: TraceTestStatus;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsResponseSuccess
 */
export interface GetDriftRunTraceTestsResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.TraceTest trace_tests = 1
     */
    traceTests: TraceTest[];
    /**
     * @generated from protobuf field: optional string next_cursor = 2
     */
    nextCursor?: string;
    /**
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsResponseError
 */
export interface GetDriftRunTraceTestsResponseError {
    /**
     * Machine-readable error code, could be an enum
     *
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * Human-readable error message
     *
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsResponse
 */
export interface GetDriftRunTraceTestsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetDriftRunTraceTestsResponseSuccess success = 1
         */
        success: GetDriftRunTraceTestsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetDriftRunTraceTestsResponseError error = 2
         */
        error: GetDriftRunTraceTestsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestRequest
 */
export interface GetTraceTestRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: string trace_test_id = 2
     */
    traceTestId: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestResponse
 */
export interface GetTraceTestResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetTraceTestResponseSuccess success = 1
         */
        success: GetTraceTestResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetTraceTestResponseError error = 2
         */
        error: GetTraceTestResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestResponseSuccess
 */
export interface GetTraceTestResponseSuccess {
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.TraceTest trace_test = 1
     */
    traceTest?: TraceTest;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestResponseError
 */
export interface GetTraceTestResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestsRequest
 */
export interface GetAllTraceTestsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string pagination_cursor = 2
     */
    paginationCursor?: string;
    /**
     * Server should provide next cursor based on this page size
     *
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * Optional filter by trace test status (e.g., DRAFT, IN_SUITE).
     * If not set, the server defaults to IN_SUITE.
     *
     * @generated from protobuf field: optional tusk.drift.backend.v1.TraceTestStatus status_filter = 4
     */
    statusFilter?: TraceTestStatus;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestsResponseSuccess
 */
export interface GetAllTraceTestsResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.TraceTest trace_tests = 1
     */
    traceTests: TraceTest[];
    /**
     * @generated from protobuf field: optional string next_cursor = 2
     */
    nextCursor?: string;
    /**
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestsResponseError
 */
export interface GetAllTraceTestsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestsResponse
 */
export interface GetAllTraceTestsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllTraceTestsResponseSuccess success = 1
         */
        success: GetAllTraceTestsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllTraceTestsResponseError error = 2
         */
        error: GetAllTraceTestsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.Deviation
 */
export interface Deviation {
    /**
     * @generated from protobuf field: string field = 1
     */
    field: string; // what field in replay span had a deviation
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string; // description of the deviation, primarily useful for comparing SUT
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.TraceTestSpanResult
 */
export interface TraceTestSpanResult {
    /**
     * Create a separate table in backend for span_result_recording, but very
     * similar schema to
     *
     * @generated from protobuf field: tusk.drift.core.v1.Span replay_span = 1
     */
    replaySpan?: Span;
    /**
     * All nullable since we want to allow for no matching span_recordings
     * This should be the DB id of the matched span_recording
     *
     * @generated from protobuf field: optional string matched_span_recording_id = 2
     */
    matchedSpanRecordingId?: string;
    /**
     * @generated from protobuf field: optional tusk.drift.core.v1.MatchLevel match_level = 3
     */
    matchLevel?: MatchLevel;
    /**
     * @generated from protobuf field: optional string stack_trace = 4
     */
    stackTrace?: string;
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.Deviation deviations = 5
     */
    deviations: Deviation[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.TraceTestResult
 */
export interface TraceTestResult {
    /**
     * @generated from protobuf field: string trace_test_id = 1
     */
    traceTestId: string; // DB id
    /**
     * @generated from protobuf field: bool test_success = 2
     */
    testSuccess: boolean;
    /**
     * @generated from protobuf field: optional tusk.drift.backend.v1.TraceTestFailureReason test_failure_reason = 3
     */
    testFailureReason?: TraceTestFailureReason;
    /**
     * @generated from protobuf field: optional string test_failure_message = 4
     */
    testFailureMessage?: string;
    /**
     * @generated from protobuf field: optional string replay_trace_id = 5
     */
    replayTraceId?: string;
    /**
     * @generated from protobuf field: optional string replay_server_span_id = 6
     */
    replayServerSpanId?: string;
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.TraceTestSpanResult span_results = 7
     */
    spanResults: TraceTestSpanResult[];
    /**
     * Per-test coverage data (only set when coverage is enabled)
     *
     * @generated from protobuf field: optional tusk.drift.backend.v1.TraceTestCoverageData coverage_data = 8
     */
    coverageData?: TraceTestCoverageData;
}
/**
 * Per-test coverage: lines covered by a single trace test
 *
 * @generated from protobuf message tusk.drift.backend.v1.TraceTestCoverageData
 */
export interface TraceTestCoverageData {
    /**
     * @generated from protobuf field: int32 total_covered_lines = 1
     */
    totalCoveredLines: number;
    /**
     * @generated from protobuf field: map<string, tusk.drift.backend.v1.FileLineRanges> covered_lines_by_file = 2
     */
    coveredLinesByFile: {
        [key: string]: FileLineRanges;
    };
}
/**
 * Compressed line ranges: [[1,50],[60,200]] stored as repeated LineRange
 *
 * @generated from protobuf message tusk.drift.backend.v1.FileLineRanges
 */
export interface FileLineRanges {
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.LineRange ranges = 1
     */
    ranges: LineRange[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.LineRange
 */
export interface LineRange {
    /**
     * @generated from protobuf field: int32 start = 1
     */
    start: number;
    /**
     * @generated from protobuf field: int32 end = 2
     */
    end: number; // inclusive
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UploadTraceTestResultsRequest
 */
export interface UploadTraceTestResultsRequest {
    /**
     * @generated from protobuf field: string drift_run_id = 1
     */
    driftRunId: string;
    /**
     * @generated from protobuf field: string cli_version = 2
     */
    cliVersion: string;
    /**
     * @generated from protobuf field: string sdk_version = 3
     */
    sdkVersion: string;
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.TraceTestResult trace_test_results = 4
     */
    traceTestResults: TraceTestResult[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UploadTraceTestResultsResponseSuccess
 */
export interface UploadTraceTestResultsResponseSuccess {
    /**
     * @generated from protobuf field: string message = 1
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UploadTraceTestResultsResponseError
 */
export interface UploadTraceTestResultsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UploadTraceTestResultsResponse
 */
export interface UploadTraceTestResultsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.UploadTraceTestResultsResponseSuccess success = 1
         */
        success: UploadTraceTestResultsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.UploadTraceTestResultsResponseError error = 2
         */
        error: UploadTraceTestResultsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusRequest
 */
export interface UpdateDriftRunCIStatusRequest {
    /**
     * @generated from protobuf field: string drift_run_id = 1
     */
    driftRunId: string;
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.DriftRunCIStatus ci_status = 2
     */
    ciStatus: DriftRunCIStatus;
    /**
     * @generated from protobuf field: optional string ci_status_message = 3
     */
    ciStatusMessage?: string;
    /**
     * Coverage baseline (only set when coverage was enabled for this run)
     *
     * @generated from protobuf field: optional tusk.drift.backend.v1.CoverageBaseline coverage_baseline = 4
     */
    coverageBaseline?: CoverageBaseline;
}
/**
 * Coverage baseline: all coverable lines in the codebase (denominator for coverage %)
 *
 * @generated from protobuf message tusk.drift.backend.v1.CoverageBaseline
 */
export interface CoverageBaseline {
    /**
     * @generated from protobuf field: string commit_sha = 1
     */
    commitSha: string;
    /**
     * @generated from protobuf field: int32 total_coverable_lines = 2
     */
    totalCoverableLines: number;
    /**
     * All coverable lines per file (denominator)
     *
     * @generated from protobuf field: map<string, tusk.drift.backend.v1.FileLineRanges> coverable_lines_by_file = 3
     */
    coverableLinesByFile: {
        [key: string]: FileLineRanges;
    };
    /**
     * Lines covered at startup (module loading, decorators, DI registration).
     * Included in the aggregate numerator to match industry standard (Istanbul, NYC, etc.).
     *
     * @generated from protobuf field: map<string, tusk.drift.backend.v1.FileLineRanges> startup_covered_lines_by_file = 4
     */
    startupCoveredLinesByFile: {
        [key: string]: FileLineRanges;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseSuccess
 */
export interface UpdateDriftRunCIStatusResponseSuccess {
    /**
     * @generated from protobuf field: string message = 1
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseError
 */
export interface UpdateDriftRunCIStatusResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusResponse
 */
export interface UpdateDriftRunCIStatusResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseSuccess success = 1
         */
        success: UpdateDriftRunCIStatusResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseError error = 2
         */
        error: UpdateDriftRunCIStatusResponseError;
    } | {
        oneofKind: undefined;
    };
}
// =============================================================================
// Suite Validation Messages
// =============================================================================

/**
 * GetValidationTraceTests - Get all traces for validation (DRAFT and IN_SUITE)
 *
 * @generated from protobuf message tusk.drift.backend.v1.GetValidationTraceTestsRequest
 */
export interface GetValidationTraceTestsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: optional string pagination_cursor = 2
     */
    paginationCursor?: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetValidationTraceTestsResponseSuccess
 */
export interface GetValidationTraceTestsResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.TraceTest trace_tests = 1
     */
    traceTests: TraceTest[];
    /**
     * @generated from protobuf field: optional string next_cursor = 2
     */
    nextCursor?: string;
    /**
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetValidationTraceTestsResponseError
 */
export interface GetValidationTraceTestsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetValidationTraceTestsResponse
 */
export interface GetValidationTraceTestsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetValidationTraceTestsResponseSuccess success = 1
         */
        success: GetValidationTraceTestsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetValidationTraceTestsResponseError error = 2
         */
        error: GetValidationTraceTestsResponseError;
    } | {
        oneofKind: undefined;
    };
}
// =============================================================================
// Cache-friendly APIs for efficient trace syncing
// =============================================================================

/**
 * GetAllTraceTestIds - Get all trace test IDs (lightweight, for cache diffing)
 *
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsRequest
 */
export interface GetAllTraceTestIdsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsResponseSuccess
 */
export interface GetAllTraceTestIdsResponseSuccess {
    /**
     * @generated from protobuf field: repeated string trace_test_ids = 1
     */
    traceTestIds: string[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsResponseError
 */
export interface GetAllTraceTestIdsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsResponse
 */
export interface GetAllTraceTestIdsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllTraceTestIdsResponseSuccess success = 1
         */
        success: GetAllTraceTestIdsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllTraceTestIdsResponseError error = 2
         */
        error: GetAllTraceTestIdsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * GetTraceTestsByIds - Batch fetch trace tests by IDs
 *
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsRequest
 */
export interface GetTraceTestsByIdsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: repeated string trace_test_ids = 2
     */
    traceTestIds: string[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsResponseSuccess
 */
export interface GetTraceTestsByIdsResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.TraceTest trace_tests = 1
     */
    traceTests: TraceTest[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsResponseError
 */
export interface GetTraceTestsByIdsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsResponse
 */
export interface GetTraceTestsByIdsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetTraceTestsByIdsResponseSuccess success = 1
         */
        success: GetTraceTestsByIdsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetTraceTestsByIdsResponseError error = 2
         */
        error: GetTraceTestsByIdsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * GetAllPreAppStartSpanIds - Get all pre-app-start span IDs (lightweight, for cache diffing)
 *
 * @generated from protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsRequest
 */
export interface GetAllPreAppStartSpanIdsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseSuccess
 */
export interface GetAllPreAppStartSpanIdsResponseSuccess {
    /**
     * @generated from protobuf field: repeated string span_ids = 1
     */
    spanIds: string[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseError
 */
export interface GetAllPreAppStartSpanIdsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponse
 */
export interface GetAllPreAppStartSpanIdsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseSuccess success = 1
         */
        success: GetAllPreAppStartSpanIdsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseError error = 2
         */
        error: GetAllPreAppStartSpanIdsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * GetPreAppStartSpansByIds - Batch fetch pre-app-start spans by IDs
 *
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsRequest
 */
export interface GetPreAppStartSpansByIdsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: repeated string span_ids = 2
     */
    spanIds: string[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseSuccess
 */
export interface GetPreAppStartSpansByIdsResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.core.v1.Span spans = 1
     */
    spans: Span[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseError
 */
export interface GetPreAppStartSpansByIdsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponse
 */
export interface GetPreAppStartSpansByIdsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseSuccess success = 1
         */
        success: GetPreAppStartSpansByIdsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseError error = 2
         */
        error: GetPreAppStartSpansByIdsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * GetAllGlobalSpanIds - Get all global span IDs (lightweight, for cache diffing)
 *
 * @generated from protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsRequest
 */
export interface GetAllGlobalSpanIdsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseSuccess
 */
export interface GetAllGlobalSpanIdsResponseSuccess {
    /**
     * @generated from protobuf field: repeated string span_ids = 1
     */
    spanIds: string[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseError
 */
export interface GetAllGlobalSpanIdsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsResponse
 */
export interface GetAllGlobalSpanIdsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseSuccess success = 1
         */
        success: GetAllGlobalSpanIdsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseError error = 2
         */
        error: GetAllGlobalSpanIdsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * GetGlobalSpansByIds - Batch fetch global spans by IDs
 *
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsRequest
 */
export interface GetGlobalSpansByIdsRequest {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
    /**
     * @generated from protobuf field: repeated string span_ids = 2
     */
    spanIds: string[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsResponseSuccess
 */
export interface GetGlobalSpansByIdsResponseSuccess {
    /**
     * @generated from protobuf field: repeated tusk.drift.core.v1.Span spans = 1
     */
    spans: Span[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsResponseError
 */
export interface GetGlobalSpansByIdsResponseError {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsResponse
 */
export interface GetGlobalSpansByIdsResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetGlobalSpansByIdsResponseSuccess success = 1
         */
        success: GetGlobalSpansByIdsResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.GetGlobalSpansByIdsResponseError error = 2
         */
        error: GetGlobalSpansByIdsResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.TraceTestStatus
 */
export enum TraceTestStatus {
    /**
     * @generated from protobuf enum value: TRACE_TEST_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TRACE_TEST_STATUS_DRAFT = 1;
     */
    DRAFT = 1,
    /**
     * @generated from protobuf enum value: TRACE_TEST_STATUS_IN_SUITE = 2;
     */
    IN_SUITE = 2,
    /**
     * @generated from protobuf enum value: TRACE_TEST_STATUS_REMOVED = 3;
     */
    REMOVED = 3
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.TraceTestFailureReason
 */
export enum TraceTestFailureReason {
    /**
     * @generated from protobuf enum value: TRACE_TEST_FAILURE_REASON_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TRACE_TEST_FAILURE_REASON_MOCK_NOT_FOUND = 1;
     */
    MOCK_NOT_FOUND = 1,
    /**
     * @generated from protobuf enum value: TRACE_TEST_FAILURE_REASON_RESPONSE_MISMATCH = 2;
     */
    RESPONSE_MISMATCH = 2,
    /**
     * @generated from protobuf enum value: TRACE_TEST_FAILURE_REASON_NO_RESPONSE = 3;
     */
    NO_RESPONSE = 3
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.DriftRunCIStatus
 */
export enum DriftRunCIStatus {
    /**
     * @generated from protobuf enum value: DRIFT_RUN_CI_STATUS_UNSPECIFIED = 0;
     */
    DRIFT_RUN_CI_STATUS_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DRIFT_RUN_CI_STATUS_RUNNING = 1;
     */
    DRIFT_RUN_CI_STATUS_RUNNING = 1,
    /**
     * @generated from protobuf enum value: DRIFT_RUN_CI_STATUS_SUCCESS = 2;
     */
    DRIFT_RUN_CI_STATUS_SUCCESS = 2,
    /**
     * @generated from protobuf enum value: DRIFT_RUN_CI_STATUS_FAILURE = 3;
     */
    DRIFT_RUN_CI_STATUS_FAILURE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansRequest$Type extends MessageType<GetGlobalSpansRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pagination_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansRequest>): GetGlobalSpansRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansRequest): GetGlobalSpansRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string pagination_cursor */ 2:
                    message.paginationCursor = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string pagination_cursor = 2; */
        if (message.paginationCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.paginationCursor);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansRequest
 */
export const GetGlobalSpansRequest = new GetGlobalSpansRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansResponseSuccess$Type extends MessageType<GetGlobalSpansResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansResponseSuccess", [
            { no: 1, name: "spans", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Span },
            { no: 2, name: "next_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansResponseSuccess>): GetGlobalSpansResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.spans = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansResponseSuccess): GetGlobalSpansResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.core.v1.Span spans */ 1:
                    message.spans.push(Span.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string next_cursor */ 2:
                    message.nextCursor = reader.string();
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.core.v1.Span spans = 1; */
        for (let i = 0; i < message.spans.length; i++)
            Span.internalBinaryWrite(message.spans[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string next_cursor = 2; */
        if (message.nextCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.nextCursor);
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansResponseSuccess
 */
export const GetGlobalSpansResponseSuccess = new GetGlobalSpansResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansResponseError$Type extends MessageType<GetGlobalSpansResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansResponseError>): GetGlobalSpansResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansResponseError): GetGlobalSpansResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansResponseError
 */
export const GetGlobalSpansResponseError = new GetGlobalSpansResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansResponse$Type extends MessageType<GetGlobalSpansResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetGlobalSpansResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetGlobalSpansResponseError }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansResponse>): GetGlobalSpansResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansResponse): GetGlobalSpansResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetGlobalSpansResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetGlobalSpansResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetGlobalSpansResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetGlobalSpansResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetGlobalSpansResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetGlobalSpansResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetGlobalSpansResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetGlobalSpansResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansResponse
 */
export const GetGlobalSpansResponse = new GetGlobalSpansResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansRequest$Type extends MessageType<GetPreAppStartSpansRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pagination_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansRequest>): GetPreAppStartSpansRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansRequest): GetPreAppStartSpansRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string pagination_cursor */ 2:
                    message.paginationCursor = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string pagination_cursor = 2; */
        if (message.paginationCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.paginationCursor);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansRequest
 */
export const GetPreAppStartSpansRequest = new GetPreAppStartSpansRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansResponseSuccess$Type extends MessageType<GetPreAppStartSpansResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansResponseSuccess", [
            { no: 1, name: "spans", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Span },
            { no: 2, name: "next_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansResponseSuccess>): GetPreAppStartSpansResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.spans = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansResponseSuccess): GetPreAppStartSpansResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.core.v1.Span spans */ 1:
                    message.spans.push(Span.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string next_cursor */ 2:
                    message.nextCursor = reader.string();
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.core.v1.Span spans = 1; */
        for (let i = 0; i < message.spans.length; i++)
            Span.internalBinaryWrite(message.spans[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string next_cursor = 2; */
        if (message.nextCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.nextCursor);
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansResponseSuccess
 */
export const GetPreAppStartSpansResponseSuccess = new GetPreAppStartSpansResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansResponseError$Type extends MessageType<GetPreAppStartSpansResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansResponseError>): GetPreAppStartSpansResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansResponseError): GetPreAppStartSpansResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansResponseError
 */
export const GetPreAppStartSpansResponseError = new GetPreAppStartSpansResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansResponse$Type extends MessageType<GetPreAppStartSpansResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetPreAppStartSpansResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetPreAppStartSpansResponseError }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansResponse>): GetPreAppStartSpansResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansResponse): GetPreAppStartSpansResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetPreAppStartSpansResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetPreAppStartSpansResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetPreAppStartSpansResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetPreAppStartSpansResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetPreAppStartSpansResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetPreAppStartSpansResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetPreAppStartSpansResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetPreAppStartSpansResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansResponse
 */
export const GetPreAppStartSpansResponse = new GetPreAppStartSpansResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDriftRunRequest$Type extends MessageType<CreateDriftRunRequest> {
    constructor() {
        super("tusk.drift.backend.v1.CreateDriftRunRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cli_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commit_sha", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pr_number", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "branch_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "external_check_run_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_validation_run", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateDriftRunRequest>): CreateDriftRunRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.cliVersion = "";
        message.isValidationRun = false;
        if (value !== undefined)
            reflectionMergePartial<CreateDriftRunRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDriftRunRequest): CreateDriftRunRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* string cli_version */ 2:
                    message.cliVersion = reader.string();
                    break;
                case /* optional string commit_sha */ 3:
                    message.commitSha = reader.string();
                    break;
                case /* optional string pr_number */ 4:
                    message.prNumber = reader.string();
                    break;
                case /* optional string branch_name */ 5:
                    message.branchName = reader.string();
                    break;
                case /* optional string external_check_run_id */ 6:
                    message.externalCheckRunId = reader.string();
                    break;
                case /* bool is_validation_run */ 7:
                    message.isValidationRun = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDriftRunRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* string cli_version = 2; */
        if (message.cliVersion !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cliVersion);
        /* optional string commit_sha = 3; */
        if (message.commitSha !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.commitSha);
        /* optional string pr_number = 4; */
        if (message.prNumber !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.prNumber);
        /* optional string branch_name = 5; */
        if (message.branchName !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.branchName);
        /* optional string external_check_run_id = 6; */
        if (message.externalCheckRunId !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.externalCheckRunId);
        /* bool is_validation_run = 7; */
        if (message.isValidationRun !== false)
            writer.tag(7, WireType.Varint).bool(message.isValidationRun);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateDriftRunRequest
 */
export const CreateDriftRunRequest = new CreateDriftRunRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDriftRunResponseSuccess$Type extends MessageType<CreateDriftRunResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.CreateDriftRunResponseSuccess", [
            { no: 1, name: "drift_run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateDriftRunResponseSuccess>): CreateDriftRunResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.driftRunId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateDriftRunResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDriftRunResponseSuccess): CreateDriftRunResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string drift_run_id */ 1:
                    message.driftRunId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDriftRunResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string drift_run_id = 1; */
        if (message.driftRunId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.driftRunId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateDriftRunResponseSuccess
 */
export const CreateDriftRunResponseSuccess = new CreateDriftRunResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDriftRunResponseError$Type extends MessageType<CreateDriftRunResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.CreateDriftRunResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateDriftRunResponseError>): CreateDriftRunResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<CreateDriftRunResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDriftRunResponseError): CreateDriftRunResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDriftRunResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateDriftRunResponseError
 */
export const CreateDriftRunResponseError = new CreateDriftRunResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDriftRunResponse$Type extends MessageType<CreateDriftRunResponse> {
    constructor() {
        super("tusk.drift.backend.v1.CreateDriftRunResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => CreateDriftRunResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => CreateDriftRunResponseError }
        ]);
    }
    create(value?: PartialMessage<CreateDriftRunResponse>): CreateDriftRunResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<CreateDriftRunResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDriftRunResponse): CreateDriftRunResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.CreateDriftRunResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: CreateDriftRunResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.CreateDriftRunResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: CreateDriftRunResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDriftRunResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.CreateDriftRunResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            CreateDriftRunResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.CreateDriftRunResponseError error = 2; */
        if (message.response.oneofKind === "error")
            CreateDriftRunResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateDriftRunResponse
 */
export const CreateDriftRunResponse = new CreateDriftRunResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDriftRunTraceTestsRequest$Type extends MessageType<GetDriftRunTraceTestsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetDriftRunTraceTestsRequest", [
            { no: 1, name: "drift_run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pagination_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetDriftRunTraceTestsRequest>): GetDriftRunTraceTestsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.driftRunId = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetDriftRunTraceTestsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDriftRunTraceTestsRequest): GetDriftRunTraceTestsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string drift_run_id */ 1:
                    message.driftRunId = reader.string();
                    break;
                case /* optional string pagination_cursor */ 2:
                    message.paginationCursor = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDriftRunTraceTestsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string drift_run_id = 1; */
        if (message.driftRunId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.driftRunId);
        /* optional string pagination_cursor = 2; */
        if (message.paginationCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.paginationCursor);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsRequest
 */
export const GetDriftRunTraceTestsRequest = new GetDriftRunTraceTestsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TraceTest$Type extends MessageType<TraceTest> {
    constructor() {
        super("tusk.drift.backend.v1.TraceTest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "server_span_recording_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "spans", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Span },
            { no: 5, name: "status", kind: "enum", T: () => ["tusk.drift.backend.v1.TraceTestStatus", TraceTestStatus, "TRACE_TEST_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<TraceTest>): TraceTest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.traceId = "";
        message.serverSpanRecordingId = "";
        message.spans = [];
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<TraceTest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TraceTest): TraceTest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string trace_id */ 2:
                    message.traceId = reader.string();
                    break;
                case /* string server_span_recording_id */ 3:
                    message.serverSpanRecordingId = reader.string();
                    break;
                case /* repeated tusk.drift.core.v1.Span spans */ 4:
                    message.spans.push(Span.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* tusk.drift.backend.v1.TraceTestStatus status */ 5:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TraceTest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string trace_id = 2; */
        if (message.traceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.traceId);
        /* string server_span_recording_id = 3; */
        if (message.serverSpanRecordingId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.serverSpanRecordingId);
        /* repeated tusk.drift.core.v1.Span spans = 4; */
        for (let i = 0; i < message.spans.length; i++)
            Span.internalBinaryWrite(message.spans[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.TraceTestStatus status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.TraceTest
 */
export const TraceTest = new TraceTest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDriftRunTraceTestsResponseSuccess$Type extends MessageType<GetDriftRunTraceTestsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetDriftRunTraceTestsResponseSuccess", [
            { no: 1, name: "trace_tests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TraceTest },
            { no: 2, name: "next_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetDriftRunTraceTestsResponseSuccess>): GetDriftRunTraceTestsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceTests = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetDriftRunTraceTestsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDriftRunTraceTestsResponseSuccess): GetDriftRunTraceTestsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.backend.v1.TraceTest trace_tests */ 1:
                    message.traceTests.push(TraceTest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string next_cursor */ 2:
                    message.nextCursor = reader.string();
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDriftRunTraceTestsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.backend.v1.TraceTest trace_tests = 1; */
        for (let i = 0; i < message.traceTests.length; i++)
            TraceTest.internalBinaryWrite(message.traceTests[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string next_cursor = 2; */
        if (message.nextCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.nextCursor);
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsResponseSuccess
 */
export const GetDriftRunTraceTestsResponseSuccess = new GetDriftRunTraceTestsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDriftRunTraceTestsResponseError$Type extends MessageType<GetDriftRunTraceTestsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetDriftRunTraceTestsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetDriftRunTraceTestsResponseError>): GetDriftRunTraceTestsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetDriftRunTraceTestsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDriftRunTraceTestsResponseError): GetDriftRunTraceTestsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDriftRunTraceTestsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsResponseError
 */
export const GetDriftRunTraceTestsResponseError = new GetDriftRunTraceTestsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDriftRunTraceTestsResponse$Type extends MessageType<GetDriftRunTraceTestsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetDriftRunTraceTestsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetDriftRunTraceTestsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetDriftRunTraceTestsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetDriftRunTraceTestsResponse>): GetDriftRunTraceTestsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetDriftRunTraceTestsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDriftRunTraceTestsResponse): GetDriftRunTraceTestsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetDriftRunTraceTestsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetDriftRunTraceTestsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetDriftRunTraceTestsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetDriftRunTraceTestsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDriftRunTraceTestsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetDriftRunTraceTestsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetDriftRunTraceTestsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetDriftRunTraceTestsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetDriftRunTraceTestsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetDriftRunTraceTestsResponse
 */
export const GetDriftRunTraceTestsResponse = new GetDriftRunTraceTestsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestRequest$Type extends MessageType<GetTraceTestRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "trace_test_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestRequest>): GetTraceTestRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.traceTestId = "";
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestRequest): GetTraceTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* string trace_test_id */ 2:
                    message.traceTestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* string trace_test_id = 2; */
        if (message.traceTestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.traceTestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestRequest
 */
export const GetTraceTestRequest = new GetTraceTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestResponse$Type extends MessageType<GetTraceTestResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetTraceTestResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetTraceTestResponseError }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestResponse>): GetTraceTestResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestResponse): GetTraceTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetTraceTestResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetTraceTestResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetTraceTestResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetTraceTestResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetTraceTestResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetTraceTestResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetTraceTestResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetTraceTestResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestResponse
 */
export const GetTraceTestResponse = new GetTraceTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestResponseSuccess$Type extends MessageType<GetTraceTestResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestResponseSuccess", [
            { no: 1, name: "trace_test", kind: "message", T: () => TraceTest }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestResponseSuccess>): GetTraceTestResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestResponseSuccess): GetTraceTestResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.TraceTest trace_test */ 1:
                    message.traceTest = TraceTest.internalBinaryRead(reader, reader.uint32(), options, message.traceTest);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.TraceTest trace_test = 1; */
        if (message.traceTest)
            TraceTest.internalBinaryWrite(message.traceTest, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestResponseSuccess
 */
export const GetTraceTestResponseSuccess = new GetTraceTestResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestResponseError$Type extends MessageType<GetTraceTestResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestResponseError>): GetTraceTestResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestResponseError): GetTraceTestResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestResponseError
 */
export const GetTraceTestResponseError = new GetTraceTestResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestsRequest$Type extends MessageType<GetAllTraceTestsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pagination_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "status_filter", kind: "enum", opt: true, T: () => ["tusk.drift.backend.v1.TraceTestStatus", TraceTestStatus, "TRACE_TEST_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestsRequest>): GetAllTraceTestsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestsRequest): GetAllTraceTestsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string pagination_cursor */ 2:
                    message.paginationCursor = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* optional tusk.drift.backend.v1.TraceTestStatus status_filter */ 4:
                    message.statusFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string pagination_cursor = 2; */
        if (message.paginationCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.paginationCursor);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* optional tusk.drift.backend.v1.TraceTestStatus status_filter = 4; */
        if (message.statusFilter !== undefined)
            writer.tag(4, WireType.Varint).int32(message.statusFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestsRequest
 */
export const GetAllTraceTestsRequest = new GetAllTraceTestsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestsResponseSuccess$Type extends MessageType<GetAllTraceTestsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestsResponseSuccess", [
            { no: 1, name: "trace_tests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TraceTest },
            { no: 2, name: "next_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestsResponseSuccess>): GetAllTraceTestsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceTests = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestsResponseSuccess): GetAllTraceTestsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.backend.v1.TraceTest trace_tests */ 1:
                    message.traceTests.push(TraceTest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string next_cursor */ 2:
                    message.nextCursor = reader.string();
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.backend.v1.TraceTest trace_tests = 1; */
        for (let i = 0; i < message.traceTests.length; i++)
            TraceTest.internalBinaryWrite(message.traceTests[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string next_cursor = 2; */
        if (message.nextCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.nextCursor);
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestsResponseSuccess
 */
export const GetAllTraceTestsResponseSuccess = new GetAllTraceTestsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestsResponseError$Type extends MessageType<GetAllTraceTestsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestsResponseError>): GetAllTraceTestsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestsResponseError): GetAllTraceTestsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestsResponseError
 */
export const GetAllTraceTestsResponseError = new GetAllTraceTestsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestsResponse$Type extends MessageType<GetAllTraceTestsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetAllTraceTestsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetAllTraceTestsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestsResponse>): GetAllTraceTestsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestsResponse): GetAllTraceTestsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetAllTraceTestsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetAllTraceTestsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetAllTraceTestsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetAllTraceTestsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetAllTraceTestsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetAllTraceTestsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetAllTraceTestsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetAllTraceTestsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestsResponse
 */
export const GetAllTraceTestsResponse = new GetAllTraceTestsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Deviation$Type extends MessageType<Deviation> {
    constructor() {
        super("tusk.drift.backend.v1.Deviation", [
            { no: 1, name: "field", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Deviation>): Deviation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.field = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<Deviation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Deviation): Deviation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string field */ 1:
                    message.field = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Deviation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string field = 1; */
        if (message.field !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.field);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.Deviation
 */
export const Deviation = new Deviation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TraceTestSpanResult$Type extends MessageType<TraceTestSpanResult> {
    constructor() {
        super("tusk.drift.backend.v1.TraceTestSpanResult", [
            { no: 1, name: "replay_span", kind: "message", T: () => Span },
            { no: 2, name: "matched_span_recording_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "match_level", kind: "message", T: () => MatchLevel },
            { no: 4, name: "stack_trace", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "deviations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Deviation }
        ]);
    }
    create(value?: PartialMessage<TraceTestSpanResult>): TraceTestSpanResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.deviations = [];
        if (value !== undefined)
            reflectionMergePartial<TraceTestSpanResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TraceTestSpanResult): TraceTestSpanResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.core.v1.Span replay_span */ 1:
                    message.replaySpan = Span.internalBinaryRead(reader, reader.uint32(), options, message.replaySpan);
                    break;
                case /* optional string matched_span_recording_id */ 2:
                    message.matchedSpanRecordingId = reader.string();
                    break;
                case /* optional tusk.drift.core.v1.MatchLevel match_level */ 3:
                    message.matchLevel = MatchLevel.internalBinaryRead(reader, reader.uint32(), options, message.matchLevel);
                    break;
                case /* optional string stack_trace */ 4:
                    message.stackTrace = reader.string();
                    break;
                case /* repeated tusk.drift.backend.v1.Deviation deviations */ 5:
                    message.deviations.push(Deviation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TraceTestSpanResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.core.v1.Span replay_span = 1; */
        if (message.replaySpan)
            Span.internalBinaryWrite(message.replaySpan, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string matched_span_recording_id = 2; */
        if (message.matchedSpanRecordingId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.matchedSpanRecordingId);
        /* optional tusk.drift.core.v1.MatchLevel match_level = 3; */
        if (message.matchLevel)
            MatchLevel.internalBinaryWrite(message.matchLevel, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional string stack_trace = 4; */
        if (message.stackTrace !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.stackTrace);
        /* repeated tusk.drift.backend.v1.Deviation deviations = 5; */
        for (let i = 0; i < message.deviations.length; i++)
            Deviation.internalBinaryWrite(message.deviations[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.TraceTestSpanResult
 */
export const TraceTestSpanResult = new TraceTestSpanResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TraceTestResult$Type extends MessageType<TraceTestResult> {
    constructor() {
        super("tusk.drift.backend.v1.TraceTestResult", [
            { no: 1, name: "trace_test_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "test_success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "test_failure_reason", kind: "enum", opt: true, T: () => ["tusk.drift.backend.v1.TraceTestFailureReason", TraceTestFailureReason, "TRACE_TEST_FAILURE_REASON_"] },
            { no: 4, name: "test_failure_message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "replay_trace_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "replay_server_span_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "span_results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TraceTestSpanResult },
            { no: 8, name: "coverage_data", kind: "message", T: () => TraceTestCoverageData }
        ]);
    }
    create(value?: PartialMessage<TraceTestResult>): TraceTestResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceTestId = "";
        message.testSuccess = false;
        message.spanResults = [];
        if (value !== undefined)
            reflectionMergePartial<TraceTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TraceTestResult): TraceTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string trace_test_id */ 1:
                    message.traceTestId = reader.string();
                    break;
                case /* bool test_success */ 2:
                    message.testSuccess = reader.bool();
                    break;
                case /* optional tusk.drift.backend.v1.TraceTestFailureReason test_failure_reason */ 3:
                    message.testFailureReason = reader.int32();
                    break;
                case /* optional string test_failure_message */ 4:
                    message.testFailureMessage = reader.string();
                    break;
                case /* optional string replay_trace_id */ 5:
                    message.replayTraceId = reader.string();
                    break;
                case /* optional string replay_server_span_id */ 6:
                    message.replayServerSpanId = reader.string();
                    break;
                case /* repeated tusk.drift.backend.v1.TraceTestSpanResult span_results */ 7:
                    message.spanResults.push(TraceTestSpanResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional tusk.drift.backend.v1.TraceTestCoverageData coverage_data */ 8:
                    message.coverageData = TraceTestCoverageData.internalBinaryRead(reader, reader.uint32(), options, message.coverageData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TraceTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string trace_test_id = 1; */
        if (message.traceTestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.traceTestId);
        /* bool test_success = 2; */
        if (message.testSuccess !== false)
            writer.tag(2, WireType.Varint).bool(message.testSuccess);
        /* optional tusk.drift.backend.v1.TraceTestFailureReason test_failure_reason = 3; */
        if (message.testFailureReason !== undefined)
            writer.tag(3, WireType.Varint).int32(message.testFailureReason);
        /* optional string test_failure_message = 4; */
        if (message.testFailureMessage !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.testFailureMessage);
        /* optional string replay_trace_id = 5; */
        if (message.replayTraceId !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.replayTraceId);
        /* optional string replay_server_span_id = 6; */
        if (message.replayServerSpanId !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.replayServerSpanId);
        /* repeated tusk.drift.backend.v1.TraceTestSpanResult span_results = 7; */
        for (let i = 0; i < message.spanResults.length; i++)
            TraceTestSpanResult.internalBinaryWrite(message.spanResults[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional tusk.drift.backend.v1.TraceTestCoverageData coverage_data = 8; */
        if (message.coverageData)
            TraceTestCoverageData.internalBinaryWrite(message.coverageData, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.TraceTestResult
 */
export const TraceTestResult = new TraceTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TraceTestCoverageData$Type extends MessageType<TraceTestCoverageData> {
    constructor() {
        super("tusk.drift.backend.v1.TraceTestCoverageData", [
            { no: 1, name: "total_covered_lines", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "covered_lines_by_file", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FileLineRanges } }
        ]);
    }
    create(value?: PartialMessage<TraceTestCoverageData>): TraceTestCoverageData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalCoveredLines = 0;
        message.coveredLinesByFile = {};
        if (value !== undefined)
            reflectionMergePartial<TraceTestCoverageData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TraceTestCoverageData): TraceTestCoverageData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_covered_lines */ 1:
                    message.totalCoveredLines = reader.int32();
                    break;
                case /* map<string, tusk.drift.backend.v1.FileLineRanges> covered_lines_by_file */ 2:
                    this.binaryReadMap2(message.coveredLinesByFile, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: TraceTestCoverageData["coveredLinesByFile"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TraceTestCoverageData["coveredLinesByFile"] | undefined, val: TraceTestCoverageData["coveredLinesByFile"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FileLineRanges.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.backend.v1.TraceTestCoverageData.covered_lines_by_file");
            }
        }
        map[key ?? ""] = val ?? FileLineRanges.create();
    }
    internalBinaryWrite(message: TraceTestCoverageData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 total_covered_lines = 1; */
        if (message.totalCoveredLines !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalCoveredLines);
        /* map<string, tusk.drift.backend.v1.FileLineRanges> covered_lines_by_file = 2; */
        for (let k of globalThis.Object.keys(message.coveredLinesByFile)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FileLineRanges.internalBinaryWrite(message.coveredLinesByFile[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.TraceTestCoverageData
 */
export const TraceTestCoverageData = new TraceTestCoverageData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileLineRanges$Type extends MessageType<FileLineRanges> {
    constructor() {
        super("tusk.drift.backend.v1.FileLineRanges", [
            { no: 1, name: "ranges", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LineRange }
        ]);
    }
    create(value?: PartialMessage<FileLineRanges>): FileLineRanges {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ranges = [];
        if (value !== undefined)
            reflectionMergePartial<FileLineRanges>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileLineRanges): FileLineRanges {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.backend.v1.LineRange ranges */ 1:
                    message.ranges.push(LineRange.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileLineRanges, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.backend.v1.LineRange ranges = 1; */
        for (let i = 0; i < message.ranges.length; i++)
            LineRange.internalBinaryWrite(message.ranges[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.FileLineRanges
 */
export const FileLineRanges = new FileLineRanges$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LineRange$Type extends MessageType<LineRange> {
    constructor() {
        super("tusk.drift.backend.v1.LineRange", [
            { no: 1, name: "start", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "end", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<LineRange>): LineRange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.start = 0;
        message.end = 0;
        if (value !== undefined)
            reflectionMergePartial<LineRange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LineRange): LineRange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 start */ 1:
                    message.start = reader.int32();
                    break;
                case /* int32 end */ 2:
                    message.end = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LineRange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 start = 1; */
        if (message.start !== 0)
            writer.tag(1, WireType.Varint).int32(message.start);
        /* int32 end = 2; */
        if (message.end !== 0)
            writer.tag(2, WireType.Varint).int32(message.end);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.LineRange
 */
export const LineRange = new LineRange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadTraceTestResultsRequest$Type extends MessageType<UploadTraceTestResultsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.UploadTraceTestResultsRequest", [
            { no: 1, name: "drift_run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cli_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sdk_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "trace_test_results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TraceTestResult }
        ]);
    }
    create(value?: PartialMessage<UploadTraceTestResultsRequest>): UploadTraceTestResultsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.driftRunId = "";
        message.cliVersion = "";
        message.sdkVersion = "";
        message.traceTestResults = [];
        if (value !== undefined)
            reflectionMergePartial<UploadTraceTestResultsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadTraceTestResultsRequest): UploadTraceTestResultsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string drift_run_id */ 1:
                    message.driftRunId = reader.string();
                    break;
                case /* string cli_version */ 2:
                    message.cliVersion = reader.string();
                    break;
                case /* string sdk_version */ 3:
                    message.sdkVersion = reader.string();
                    break;
                case /* repeated tusk.drift.backend.v1.TraceTestResult trace_test_results */ 4:
                    message.traceTestResults.push(TraceTestResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadTraceTestResultsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string drift_run_id = 1; */
        if (message.driftRunId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.driftRunId);
        /* string cli_version = 2; */
        if (message.cliVersion !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cliVersion);
        /* string sdk_version = 3; */
        if (message.sdkVersion !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sdkVersion);
        /* repeated tusk.drift.backend.v1.TraceTestResult trace_test_results = 4; */
        for (let i = 0; i < message.traceTestResults.length; i++)
            TraceTestResult.internalBinaryWrite(message.traceTestResults[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UploadTraceTestResultsRequest
 */
export const UploadTraceTestResultsRequest = new UploadTraceTestResultsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadTraceTestResultsResponseSuccess$Type extends MessageType<UploadTraceTestResultsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.UploadTraceTestResultsResponseSuccess", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UploadTraceTestResultsResponseSuccess>): UploadTraceTestResultsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<UploadTraceTestResultsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadTraceTestResultsResponseSuccess): UploadTraceTestResultsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadTraceTestResultsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UploadTraceTestResultsResponseSuccess
 */
export const UploadTraceTestResultsResponseSuccess = new UploadTraceTestResultsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadTraceTestResultsResponseError$Type extends MessageType<UploadTraceTestResultsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.UploadTraceTestResultsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UploadTraceTestResultsResponseError>): UploadTraceTestResultsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<UploadTraceTestResultsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadTraceTestResultsResponseError): UploadTraceTestResultsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadTraceTestResultsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UploadTraceTestResultsResponseError
 */
export const UploadTraceTestResultsResponseError = new UploadTraceTestResultsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadTraceTestResultsResponse$Type extends MessageType<UploadTraceTestResultsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.UploadTraceTestResultsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => UploadTraceTestResultsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => UploadTraceTestResultsResponseError }
        ]);
    }
    create(value?: PartialMessage<UploadTraceTestResultsResponse>): UploadTraceTestResultsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UploadTraceTestResultsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadTraceTestResultsResponse): UploadTraceTestResultsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.UploadTraceTestResultsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: UploadTraceTestResultsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.UploadTraceTestResultsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: UploadTraceTestResultsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadTraceTestResultsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.UploadTraceTestResultsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            UploadTraceTestResultsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.UploadTraceTestResultsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            UploadTraceTestResultsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UploadTraceTestResultsResponse
 */
export const UploadTraceTestResultsResponse = new UploadTraceTestResultsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDriftRunCIStatusRequest$Type extends MessageType<UpdateDriftRunCIStatusRequest> {
    constructor() {
        super("tusk.drift.backend.v1.UpdateDriftRunCIStatusRequest", [
            { no: 1, name: "drift_run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ci_status", kind: "enum", T: () => ["tusk.drift.backend.v1.DriftRunCIStatus", DriftRunCIStatus] },
            { no: 3, name: "ci_status_message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "coverage_baseline", kind: "message", T: () => CoverageBaseline }
        ]);
    }
    create(value?: PartialMessage<UpdateDriftRunCIStatusRequest>): UpdateDriftRunCIStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.driftRunId = "";
        message.ciStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateDriftRunCIStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDriftRunCIStatusRequest): UpdateDriftRunCIStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string drift_run_id */ 1:
                    message.driftRunId = reader.string();
                    break;
                case /* tusk.drift.backend.v1.DriftRunCIStatus ci_status */ 2:
                    message.ciStatus = reader.int32();
                    break;
                case /* optional string ci_status_message */ 3:
                    message.ciStatusMessage = reader.string();
                    break;
                case /* optional tusk.drift.backend.v1.CoverageBaseline coverage_baseline */ 4:
                    message.coverageBaseline = CoverageBaseline.internalBinaryRead(reader, reader.uint32(), options, message.coverageBaseline);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDriftRunCIStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string drift_run_id = 1; */
        if (message.driftRunId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.driftRunId);
        /* tusk.drift.backend.v1.DriftRunCIStatus ci_status = 2; */
        if (message.ciStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.ciStatus);
        /* optional string ci_status_message = 3; */
        if (message.ciStatusMessage !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.ciStatusMessage);
        /* optional tusk.drift.backend.v1.CoverageBaseline coverage_baseline = 4; */
        if (message.coverageBaseline)
            CoverageBaseline.internalBinaryWrite(message.coverageBaseline, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusRequest
 */
export const UpdateDriftRunCIStatusRequest = new UpdateDriftRunCIStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoverageBaseline$Type extends MessageType<CoverageBaseline> {
    constructor() {
        super("tusk.drift.backend.v1.CoverageBaseline", [
            { no: 1, name: "commit_sha", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "total_coverable_lines", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "coverable_lines_by_file", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FileLineRanges } },
            { no: 4, name: "startup_covered_lines_by_file", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FileLineRanges } }
        ]);
    }
    create(value?: PartialMessage<CoverageBaseline>): CoverageBaseline {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.commitSha = "";
        message.totalCoverableLines = 0;
        message.coverableLinesByFile = {};
        message.startupCoveredLinesByFile = {};
        if (value !== undefined)
            reflectionMergePartial<CoverageBaseline>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoverageBaseline): CoverageBaseline {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string commit_sha */ 1:
                    message.commitSha = reader.string();
                    break;
                case /* int32 total_coverable_lines */ 2:
                    message.totalCoverableLines = reader.int32();
                    break;
                case /* map<string, tusk.drift.backend.v1.FileLineRanges> coverable_lines_by_file */ 3:
                    this.binaryReadMap3(message.coverableLinesByFile, reader, options);
                    break;
                case /* map<string, tusk.drift.backend.v1.FileLineRanges> startup_covered_lines_by_file */ 4:
                    this.binaryReadMap4(message.startupCoveredLinesByFile, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: CoverageBaseline["coverableLinesByFile"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CoverageBaseline["coverableLinesByFile"] | undefined, val: CoverageBaseline["coverableLinesByFile"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FileLineRanges.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.backend.v1.CoverageBaseline.coverable_lines_by_file");
            }
        }
        map[key ?? ""] = val ?? FileLineRanges.create();
    }
    private binaryReadMap4(map: CoverageBaseline["startupCoveredLinesByFile"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CoverageBaseline["startupCoveredLinesByFile"] | undefined, val: CoverageBaseline["startupCoveredLinesByFile"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FileLineRanges.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.backend.v1.CoverageBaseline.startup_covered_lines_by_file");
            }
        }
        map[key ?? ""] = val ?? FileLineRanges.create();
    }
    internalBinaryWrite(message: CoverageBaseline, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string commit_sha = 1; */
        if (message.commitSha !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.commitSha);
        /* int32 total_coverable_lines = 2; */
        if (message.totalCoverableLines !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCoverableLines);
        /* map<string, tusk.drift.backend.v1.FileLineRanges> coverable_lines_by_file = 3; */
        for (let k of globalThis.Object.keys(message.coverableLinesByFile)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FileLineRanges.internalBinaryWrite(message.coverableLinesByFile[k], writer, options);
            writer.join().join();
        }
        /* map<string, tusk.drift.backend.v1.FileLineRanges> startup_covered_lines_by_file = 4; */
        for (let k of globalThis.Object.keys(message.startupCoveredLinesByFile)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FileLineRanges.internalBinaryWrite(message.startupCoveredLinesByFile[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CoverageBaseline
 */
export const CoverageBaseline = new CoverageBaseline$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDriftRunCIStatusResponseSuccess$Type extends MessageType<UpdateDriftRunCIStatusResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseSuccess", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateDriftRunCIStatusResponseSuccess>): UpdateDriftRunCIStatusResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateDriftRunCIStatusResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDriftRunCIStatusResponseSuccess): UpdateDriftRunCIStatusResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDriftRunCIStatusResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseSuccess
 */
export const UpdateDriftRunCIStatusResponseSuccess = new UpdateDriftRunCIStatusResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDriftRunCIStatusResponseError$Type extends MessageType<UpdateDriftRunCIStatusResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateDriftRunCIStatusResponseError>): UpdateDriftRunCIStatusResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateDriftRunCIStatusResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDriftRunCIStatusResponseError): UpdateDriftRunCIStatusResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDriftRunCIStatusResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseError
 */
export const UpdateDriftRunCIStatusResponseError = new UpdateDriftRunCIStatusResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDriftRunCIStatusResponse$Type extends MessageType<UpdateDriftRunCIStatusResponse> {
    constructor() {
        super("tusk.drift.backend.v1.UpdateDriftRunCIStatusResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => UpdateDriftRunCIStatusResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => UpdateDriftRunCIStatusResponseError }
        ]);
    }
    create(value?: PartialMessage<UpdateDriftRunCIStatusResponse>): UpdateDriftRunCIStatusResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UpdateDriftRunCIStatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDriftRunCIStatusResponse): UpdateDriftRunCIStatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: UpdateDriftRunCIStatusResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: UpdateDriftRunCIStatusResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDriftRunCIStatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            UpdateDriftRunCIStatusResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.UpdateDriftRunCIStatusResponseError error = 2; */
        if (message.response.oneofKind === "error")
            UpdateDriftRunCIStatusResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UpdateDriftRunCIStatusResponse
 */
export const UpdateDriftRunCIStatusResponse = new UpdateDriftRunCIStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetValidationTraceTestsRequest$Type extends MessageType<GetValidationTraceTestsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetValidationTraceTestsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pagination_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetValidationTraceTestsRequest>): GetValidationTraceTestsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetValidationTraceTestsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetValidationTraceTestsRequest): GetValidationTraceTestsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* optional string pagination_cursor */ 2:
                    message.paginationCursor = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetValidationTraceTestsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* optional string pagination_cursor = 2; */
        if (message.paginationCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.paginationCursor);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetValidationTraceTestsRequest
 */
export const GetValidationTraceTestsRequest = new GetValidationTraceTestsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetValidationTraceTestsResponseSuccess$Type extends MessageType<GetValidationTraceTestsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetValidationTraceTestsResponseSuccess", [
            { no: 1, name: "trace_tests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TraceTest },
            { no: 2, name: "next_cursor", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetValidationTraceTestsResponseSuccess>): GetValidationTraceTestsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceTests = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetValidationTraceTestsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetValidationTraceTestsResponseSuccess): GetValidationTraceTestsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.backend.v1.TraceTest trace_tests */ 1:
                    message.traceTests.push(TraceTest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string next_cursor */ 2:
                    message.nextCursor = reader.string();
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetValidationTraceTestsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.backend.v1.TraceTest trace_tests = 1; */
        for (let i = 0; i < message.traceTests.length; i++)
            TraceTest.internalBinaryWrite(message.traceTests[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional string next_cursor = 2; */
        if (message.nextCursor !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.nextCursor);
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetValidationTraceTestsResponseSuccess
 */
export const GetValidationTraceTestsResponseSuccess = new GetValidationTraceTestsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetValidationTraceTestsResponseError$Type extends MessageType<GetValidationTraceTestsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetValidationTraceTestsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetValidationTraceTestsResponseError>): GetValidationTraceTestsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetValidationTraceTestsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetValidationTraceTestsResponseError): GetValidationTraceTestsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetValidationTraceTestsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetValidationTraceTestsResponseError
 */
export const GetValidationTraceTestsResponseError = new GetValidationTraceTestsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetValidationTraceTestsResponse$Type extends MessageType<GetValidationTraceTestsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetValidationTraceTestsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetValidationTraceTestsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetValidationTraceTestsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetValidationTraceTestsResponse>): GetValidationTraceTestsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetValidationTraceTestsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetValidationTraceTestsResponse): GetValidationTraceTestsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetValidationTraceTestsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetValidationTraceTestsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetValidationTraceTestsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetValidationTraceTestsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetValidationTraceTestsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetValidationTraceTestsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetValidationTraceTestsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetValidationTraceTestsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetValidationTraceTestsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetValidationTraceTestsResponse
 */
export const GetValidationTraceTestsResponse = new GetValidationTraceTestsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestIdsRequest$Type extends MessageType<GetAllTraceTestIdsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestIdsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestIdsRequest>): GetAllTraceTestIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestIdsRequest): GetAllTraceTestIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsRequest
 */
export const GetAllTraceTestIdsRequest = new GetAllTraceTestIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestIdsResponseSuccess$Type extends MessageType<GetAllTraceTestIdsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestIdsResponseSuccess", [
            { no: 1, name: "trace_test_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestIdsResponseSuccess>): GetAllTraceTestIdsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceTestIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestIdsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestIdsResponseSuccess): GetAllTraceTestIdsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string trace_test_ids */ 1:
                    message.traceTestIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestIdsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string trace_test_ids = 1; */
        for (let i = 0; i < message.traceTestIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.traceTestIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsResponseSuccess
 */
export const GetAllTraceTestIdsResponseSuccess = new GetAllTraceTestIdsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestIdsResponseError$Type extends MessageType<GetAllTraceTestIdsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestIdsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestIdsResponseError>): GetAllTraceTestIdsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestIdsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestIdsResponseError): GetAllTraceTestIdsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestIdsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsResponseError
 */
export const GetAllTraceTestIdsResponseError = new GetAllTraceTestIdsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTraceTestIdsResponse$Type extends MessageType<GetAllTraceTestIdsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllTraceTestIdsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetAllTraceTestIdsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetAllTraceTestIdsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetAllTraceTestIdsResponse>): GetAllTraceTestIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetAllTraceTestIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTraceTestIdsResponse): GetAllTraceTestIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetAllTraceTestIdsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetAllTraceTestIdsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetAllTraceTestIdsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetAllTraceTestIdsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTraceTestIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetAllTraceTestIdsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetAllTraceTestIdsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetAllTraceTestIdsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetAllTraceTestIdsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllTraceTestIdsResponse
 */
export const GetAllTraceTestIdsResponse = new GetAllTraceTestIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestsByIdsRequest$Type extends MessageType<GetTraceTestsByIdsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestsByIdsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "trace_test_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestsByIdsRequest>): GetTraceTestsByIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.traceTestIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestsByIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestsByIdsRequest): GetTraceTestsByIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* repeated string trace_test_ids */ 2:
                    message.traceTestIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestsByIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* repeated string trace_test_ids = 2; */
        for (let i = 0; i < message.traceTestIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.traceTestIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsRequest
 */
export const GetTraceTestsByIdsRequest = new GetTraceTestsByIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestsByIdsResponseSuccess$Type extends MessageType<GetTraceTestsByIdsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestsByIdsResponseSuccess", [
            { no: 1, name: "trace_tests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TraceTest }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestsByIdsResponseSuccess>): GetTraceTestsByIdsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceTests = [];
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestsByIdsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestsByIdsResponseSuccess): GetTraceTestsByIdsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.backend.v1.TraceTest trace_tests */ 1:
                    message.traceTests.push(TraceTest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestsByIdsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.backend.v1.TraceTest trace_tests = 1; */
        for (let i = 0; i < message.traceTests.length; i++)
            TraceTest.internalBinaryWrite(message.traceTests[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsResponseSuccess
 */
export const GetTraceTestsByIdsResponseSuccess = new GetTraceTestsByIdsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestsByIdsResponseError$Type extends MessageType<GetTraceTestsByIdsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestsByIdsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestsByIdsResponseError>): GetTraceTestsByIdsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestsByIdsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestsByIdsResponseError): GetTraceTestsByIdsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestsByIdsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsResponseError
 */
export const GetTraceTestsByIdsResponseError = new GetTraceTestsByIdsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTraceTestsByIdsResponse$Type extends MessageType<GetTraceTestsByIdsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetTraceTestsByIdsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetTraceTestsByIdsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetTraceTestsByIdsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetTraceTestsByIdsResponse>): GetTraceTestsByIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetTraceTestsByIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTraceTestsByIdsResponse): GetTraceTestsByIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetTraceTestsByIdsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetTraceTestsByIdsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetTraceTestsByIdsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetTraceTestsByIdsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTraceTestsByIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetTraceTestsByIdsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetTraceTestsByIdsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetTraceTestsByIdsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetTraceTestsByIdsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetTraceTestsByIdsResponse
 */
export const GetTraceTestsByIdsResponse = new GetTraceTestsByIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPreAppStartSpanIdsRequest$Type extends MessageType<GetAllPreAppStartSpanIdsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllPreAppStartSpanIdsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllPreAppStartSpanIdsRequest>): GetAllPreAppStartSpanIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllPreAppStartSpanIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllPreAppStartSpanIdsRequest): GetAllPreAppStartSpanIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllPreAppStartSpanIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsRequest
 */
export const GetAllPreAppStartSpanIdsRequest = new GetAllPreAppStartSpanIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPreAppStartSpanIdsResponseSuccess$Type extends MessageType<GetAllPreAppStartSpanIdsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseSuccess", [
            { no: 1, name: "span_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllPreAppStartSpanIdsResponseSuccess>): GetAllPreAppStartSpanIdsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.spanIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllPreAppStartSpanIdsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllPreAppStartSpanIdsResponseSuccess): GetAllPreAppStartSpanIdsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string span_ids */ 1:
                    message.spanIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllPreAppStartSpanIdsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string span_ids = 1; */
        for (let i = 0; i < message.spanIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.spanIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseSuccess
 */
export const GetAllPreAppStartSpanIdsResponseSuccess = new GetAllPreAppStartSpanIdsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPreAppStartSpanIdsResponseError$Type extends MessageType<GetAllPreAppStartSpanIdsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllPreAppStartSpanIdsResponseError>): GetAllPreAppStartSpanIdsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllPreAppStartSpanIdsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllPreAppStartSpanIdsResponseError): GetAllPreAppStartSpanIdsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllPreAppStartSpanIdsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseError
 */
export const GetAllPreAppStartSpanIdsResponseError = new GetAllPreAppStartSpanIdsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPreAppStartSpanIdsResponse$Type extends MessageType<GetAllPreAppStartSpanIdsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetAllPreAppStartSpanIdsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetAllPreAppStartSpanIdsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetAllPreAppStartSpanIdsResponse>): GetAllPreAppStartSpanIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetAllPreAppStartSpanIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllPreAppStartSpanIdsResponse): GetAllPreAppStartSpanIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetAllPreAppStartSpanIdsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetAllPreAppStartSpanIdsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllPreAppStartSpanIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetAllPreAppStartSpanIdsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetAllPreAppStartSpanIdsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllPreAppStartSpanIdsResponse
 */
export const GetAllPreAppStartSpanIdsResponse = new GetAllPreAppStartSpanIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansByIdsRequest$Type extends MessageType<GetPreAppStartSpansByIdsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansByIdsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "span_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansByIdsRequest>): GetPreAppStartSpansByIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.spanIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansByIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansByIdsRequest): GetPreAppStartSpansByIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* repeated string span_ids */ 2:
                    message.spanIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansByIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* repeated string span_ids = 2; */
        for (let i = 0; i < message.spanIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.spanIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsRequest
 */
export const GetPreAppStartSpansByIdsRequest = new GetPreAppStartSpansByIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansByIdsResponseSuccess$Type extends MessageType<GetPreAppStartSpansByIdsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseSuccess", [
            { no: 1, name: "spans", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Span }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansByIdsResponseSuccess>): GetPreAppStartSpansByIdsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.spans = [];
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansByIdsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansByIdsResponseSuccess): GetPreAppStartSpansByIdsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.core.v1.Span spans */ 1:
                    message.spans.push(Span.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansByIdsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.core.v1.Span spans = 1; */
        for (let i = 0; i < message.spans.length; i++)
            Span.internalBinaryWrite(message.spans[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseSuccess
 */
export const GetPreAppStartSpansByIdsResponseSuccess = new GetPreAppStartSpansByIdsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansByIdsResponseError$Type extends MessageType<GetPreAppStartSpansByIdsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansByIdsResponseError>): GetPreAppStartSpansByIdsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansByIdsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansByIdsResponseError): GetPreAppStartSpansByIdsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansByIdsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseError
 */
export const GetPreAppStartSpansByIdsResponseError = new GetPreAppStartSpansByIdsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPreAppStartSpansByIdsResponse$Type extends MessageType<GetPreAppStartSpansByIdsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetPreAppStartSpansByIdsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetPreAppStartSpansByIdsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetPreAppStartSpansByIdsResponse>): GetPreAppStartSpansByIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetPreAppStartSpansByIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPreAppStartSpansByIdsResponse): GetPreAppStartSpansByIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetPreAppStartSpansByIdsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetPreAppStartSpansByIdsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPreAppStartSpansByIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetPreAppStartSpansByIdsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetPreAppStartSpansByIdsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetPreAppStartSpansByIdsResponse
 */
export const GetPreAppStartSpansByIdsResponse = new GetPreAppStartSpansByIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllGlobalSpanIdsRequest$Type extends MessageType<GetAllGlobalSpanIdsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllGlobalSpanIdsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllGlobalSpanIdsRequest>): GetAllGlobalSpanIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllGlobalSpanIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllGlobalSpanIdsRequest): GetAllGlobalSpanIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllGlobalSpanIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsRequest
 */
export const GetAllGlobalSpanIdsRequest = new GetAllGlobalSpanIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllGlobalSpanIdsResponseSuccess$Type extends MessageType<GetAllGlobalSpanIdsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseSuccess", [
            { no: 1, name: "span_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllGlobalSpanIdsResponseSuccess>): GetAllGlobalSpanIdsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.spanIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllGlobalSpanIdsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllGlobalSpanIdsResponseSuccess): GetAllGlobalSpanIdsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string span_ids */ 1:
                    message.spanIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllGlobalSpanIdsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string span_ids = 1; */
        for (let i = 0; i < message.spanIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.spanIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseSuccess
 */
export const GetAllGlobalSpanIdsResponseSuccess = new GetAllGlobalSpanIdsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllGlobalSpanIdsResponseError$Type extends MessageType<GetAllGlobalSpanIdsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllGlobalSpanIdsResponseError>): GetAllGlobalSpanIdsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetAllGlobalSpanIdsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllGlobalSpanIdsResponseError): GetAllGlobalSpanIdsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllGlobalSpanIdsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseError
 */
export const GetAllGlobalSpanIdsResponseError = new GetAllGlobalSpanIdsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllGlobalSpanIdsResponse$Type extends MessageType<GetAllGlobalSpanIdsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetAllGlobalSpanIdsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetAllGlobalSpanIdsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetAllGlobalSpanIdsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetAllGlobalSpanIdsResponse>): GetAllGlobalSpanIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetAllGlobalSpanIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllGlobalSpanIdsResponse): GetAllGlobalSpanIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetAllGlobalSpanIdsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetAllGlobalSpanIdsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllGlobalSpanIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetAllGlobalSpanIdsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetAllGlobalSpanIdsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetAllGlobalSpanIdsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAllGlobalSpanIdsResponse
 */
export const GetAllGlobalSpanIdsResponse = new GetAllGlobalSpanIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansByIdsRequest$Type extends MessageType<GetGlobalSpansByIdsRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansByIdsRequest", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "span_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansByIdsRequest>): GetGlobalSpansByIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        message.spanIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansByIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansByIdsRequest): GetGlobalSpansByIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                case /* repeated string span_ids */ 2:
                    message.spanIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansByIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        /* repeated string span_ids = 2; */
        for (let i = 0; i < message.spanIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.spanIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsRequest
 */
export const GetGlobalSpansByIdsRequest = new GetGlobalSpansByIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansByIdsResponseSuccess$Type extends MessageType<GetGlobalSpansByIdsResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansByIdsResponseSuccess", [
            { no: 1, name: "spans", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Span }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansByIdsResponseSuccess>): GetGlobalSpansByIdsResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.spans = [];
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansByIdsResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansByIdsResponseSuccess): GetGlobalSpansByIdsResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated tusk.drift.core.v1.Span spans */ 1:
                    message.spans.push(Span.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansByIdsResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated tusk.drift.core.v1.Span spans = 1; */
        for (let i = 0; i < message.spans.length; i++)
            Span.internalBinaryWrite(message.spans[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsResponseSuccess
 */
export const GetGlobalSpansByIdsResponseSuccess = new GetGlobalSpansByIdsResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansByIdsResponseError$Type extends MessageType<GetGlobalSpansByIdsResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansByIdsResponseError", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansByIdsResponseError>): GetGlobalSpansByIdsResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansByIdsResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansByIdsResponseError): GetGlobalSpansByIdsResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansByIdsResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsResponseError
 */
export const GetGlobalSpansByIdsResponseError = new GetGlobalSpansByIdsResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGlobalSpansByIdsResponse$Type extends MessageType<GetGlobalSpansByIdsResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetGlobalSpansByIdsResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => GetGlobalSpansByIdsResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => GetGlobalSpansByIdsResponseError }
        ]);
    }
    create(value?: PartialMessage<GetGlobalSpansByIdsResponse>): GetGlobalSpansByIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetGlobalSpansByIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGlobalSpansByIdsResponse): GetGlobalSpansByIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.GetGlobalSpansByIdsResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: GetGlobalSpansByIdsResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.GetGlobalSpansByIdsResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: GetGlobalSpansByIdsResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGlobalSpansByIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.GetGlobalSpansByIdsResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            GetGlobalSpansByIdsResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.GetGlobalSpansByIdsResponseError error = 2; */
        if (message.response.oneofKind === "error")
            GetGlobalSpansByIdsResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetGlobalSpansByIdsResponse
 */
export const GetGlobalSpansByIdsResponse = new GetGlobalSpansByIdsResponse$Type();
/**
 * @generated ServiceType for protobuf service tusk.drift.backend.v1.TestRunService
 */
export const TestRunService = new ServiceType("tusk.drift.backend.v1.TestRunService", [
    { name: "GetGlobalSpans", options: {}, I: GetGlobalSpansRequest, O: GetGlobalSpansResponse },
    { name: "GetPreAppStartSpans", options: {}, I: GetPreAppStartSpansRequest, O: GetPreAppStartSpansResponse },
    { name: "CreateDriftRun", options: {}, I: CreateDriftRunRequest, O: CreateDriftRunResponse },
    { name: "GetDriftRunTraceTests", options: {}, I: GetDriftRunTraceTestsRequest, O: GetDriftRunTraceTestsResponse },
    { name: "GetAllTraceTests", options: {}, I: GetAllTraceTestsRequest, O: GetAllTraceTestsResponse },
    { name: "GetTraceTest", options: {}, I: GetTraceTestRequest, O: GetTraceTestResponse },
    { name: "UploadTraceTestResults", options: {}, I: UploadTraceTestResultsRequest, O: UploadTraceTestResultsResponse },
    { name: "UpdateDriftRunCIStatus", options: {}, I: UpdateDriftRunCIStatusRequest, O: UpdateDriftRunCIStatusResponse },
    { name: "GetValidationTraceTests", options: {}, I: GetValidationTraceTestsRequest, O: GetValidationTraceTestsResponse },
    { name: "GetAllTraceTestIds", options: {}, I: GetAllTraceTestIdsRequest, O: GetAllTraceTestIdsResponse },
    { name: "GetTraceTestsByIds", options: {}, I: GetTraceTestsByIdsRequest, O: GetTraceTestsByIdsResponse },
    { name: "GetAllPreAppStartSpanIds", options: {}, I: GetAllPreAppStartSpanIdsRequest, O: GetAllPreAppStartSpanIdsResponse },
    { name: "GetPreAppStartSpansByIds", options: {}, I: GetPreAppStartSpansByIdsRequest, O: GetPreAppStartSpansByIdsResponse },
    { name: "GetAllGlobalSpanIds", options: {}, I: GetAllGlobalSpanIdsRequest, O: GetAllGlobalSpanIdsResponse },
    { name: "GetGlobalSpansByIds", options: {}, I: GetGlobalSpansByIdsRequest, O: GetGlobalSpansByIdsResponse }
]);
